export const SNOWFLAKE_REQUEST = 'SNOWFLAKE_REQUEST'
export const SNOWFLAKE_SUCCESS = 'SNOWFLAKE_SUCCESS'
export const TABLES_SUCCESS = 'TABLES_SUCCESS'
export const TABLES_FAILURE = 'TABLES_FAILURE'
export const COLUMNS_SUCCESS = 'COLUMNS_SUCCESS'
export const COLUMNS_FAILURE = 'COLUMNS_FAILURE'
export const SNOWFLAKE_FAILURE = 'SNOWFLAKE_FAILURE'
export const LOGOUT = 'SNOWFLAKE_LOGOUT'